<template>
  <div>
    <PlatformBlSol
      ref="platform"
      :bridge="bridge"
      :localStoragePrefix="localStoragePrefix"
      :buttons="buttons"
      :outputs="outputs"
      :uarts="uarts"
      :leds="leds"
      :languages="languages"
      :vbusSpecifications="vbusSpecifications"
      @initialized="platformInitialized"
    ></PlatformBlSol>
  </div>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformBlSol from '@/device-platforms/PlatformBlSol.vue';

const SpecificationFile = require('resol-vbus/src/specification-file');
const Specification = require('resol-vbus/src/specification');

export default {
  props: [
    'localStoragePrefix',
  ],

  components: {
    PlatformBlSol,
  },

  data: () => ({
    label: 'RESOL DeltaSol BS 1.03',
    wasmUrl:'/W0040400_DeltaSol_BS4_2009_103-SNAPSHOT-DW.wasm',
    wasmModule: null,
    bridge: null,
    vbusSpecifications: [],

    buttons: [
      { platformIndex: 0, conversion: 'temperature', value: null, initialValue: 12.3, name: 'S1', }, // Pt1000
      { platformIndex: 1, conversion: 'temperature', value: null, initialValue: 52.3, name: 'S2', }, // Pt1000
      { platformIndex: 2, conversion: 'temperature', value: null, initialValue: 62.3, name: 'S3', }, // Pt1000
      { platformIndex: 3, conversion: 'temperature', value: null, initialValue: 72.3, name: 'S4', }, // Pt1000
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercentIncorrectlyScaled', value: null }, // Relais
      { name: 'R2', conversion: 'dutycyclePercentIncorrectlyScaled', value: null }, // Relais
    ],

    leds: [
        { state: null }
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', label: 'GP' },
      { name: 'UART1', kind: 'VBus', label: 'DDS' },
    ],

    languages: [
      { value: 0, text: 'Deutsch', short: 'de' },
      { value: 1, text: 'English', short: 'en' },
    ],
  }),

  created() {
  },

  mounted() {
  },

  methods: {
    async prepareDevice() {
      const response = await fetch(this.wasmUrl);
      const wasmArrayBuffer = await response.arrayBuffer();
      // console.log(wasmArrayBuffer);

      this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
      // console.log(this.wasmModule);

      this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
      await this.bridge.instantiate();

      this.$refs.platform.prepareBridgeable();

      const vsfResponse = await fetch('/vbus_specification.vsf');
      const vsfArrayBuffer = await vsfResponse.arrayBuffer();
      const vsfBuffer = Buffer.from(vsfArrayBuffer);
      const specificationFile = new SpecificationFile(vsfBuffer);
      const specification = new Specification({ specificationFile });
      this.vbusSpecifications.push(specification);
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
